import React, { useEffect, useMemo, useState } from 'react'
import verical_line_chart from '../../../../images/search_profession/vertical_line-chart.png'

import { useSelector } from 'react-redux'
import variableLanguage from '../../../utils/hooks/hookGetVariablesLanguage'
import { Spin } from 'antd'

const VerticalProgress = ({ percent, name, setActiveVacancy, activeVacancy, elem }) => {
  let flagStyle = typeof activeVacancy !== 'undefined'
  let handleActiveId = () => {
    setActiveVacancy(elem)
    const element = document.getElementById(elem.id)
    const container = document.querySelector('#scroll-container')
    if (element && container) {
      container.scrollTop = element.offsetTop - container.offsetTop
      // element.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }
  return (
    <div
      className={
        elem.id !== null && flagStyle && activeVacancy?.id === elem.id
          ? 'progress vertical blue'
          : 'progress vertical'
      }
      onClick={handleActiveId}
      style={{ cursor: 'pointer' }}
    >
      <div
        style={{ height: `${percent}%` }}
        className={percent < 5 ? 'progress-bar hidden' : 'progress-bar'}
      >
        <span className="sr-only">{/*{`${progress}%`}*/}</span>
      </div>
      <div className="name_employer">{name}</div>
    </div>
  )
}

const ParentBlockProgressVertical = (props) => {
  let { allJobs, setActiveVacancy, activeVacancy, activeProfession } = props
  const variables_11 = variableLanguage({
    keyPage: 'searchProfession',
    keyVariable: 'variables_11',
  })
  const [salaryArray, setSalaryArray] = useState([])
  const [copySalary, setCopySalary] = useState([])
  const { flagLoadingVacancy } = useSelector((state) => state.SearchProfession)
  let calcSalary = (elem) => {
    if (elem.salary && elem.salary.average) {
      if (elem.salary.currency === 'RUR') return elem.salary.average + ' ₽'
      if (elem.salary.currency === 'EUR') return elem.salary.average + ' €'
      if (elem.salary.currency === 'USD') return elem.salary.average + ' $'
      return ''
    }
    return 0
  }
  let calcVerticalPercent = (indx) => {
    let count =
      copySalary.filter((elem) => {
        if (typeof elem.salary.average !== 'undefined') {
          return elem
        }
      }).length - 1
    let countAdaptive
    switch (
      count // добавить px для акдеватной высоты прогресс-бара.
    ) {
      /*   case 10:
                   countAdaptive = 0;
                   break;
               case 9:
                   countAdaptive = 0;
                   break;
               case 8:
                   countAdaptive = 0;
                   break;
               case 7:
                   countAdaptive = 0;
                   break;
               case 6:
                   countAdaptive = 0;
                   break;
               case 5:
                   countAdaptive = 0;
                   break;
               case 4:
                   countAdaptive = 0;
                   break;
               case 3:
                   countAdaptive = 0;
                   break;*/
      default:
        countAdaptive = 0
    }
    const height = 380
    let procent = ((height / count + countAdaptive) / height) * 100
    if (indx === count) {
      return 100 // если последний график - всегда 100% высота
    }
    if (indx === 0) {
      return 0 // если первый график - всегда 0% высота
    }
    return Math.round(procent * indx)
  }

  useEffect(() => {
    if (allJobs && allJobs.length > 0) {
      let newArr = [...allJobs]
      // в вакансии может быть ЗП "от n" и "до n".
      // Что-бы адекватно сортировать, складываются эти цифры в среднее,
      // и в дальнейшем сортируются по этому ключу salary.average
      for (let i = 0; i < newArr.length; i++) {
        let salary = newArr[i].salary
        if (salary) {
          if (salary.from && salary.to) {
            newArr[i].salary.average = (salary.from + salary.to) / 2
            continue
          }
          if (salary.to) {
            newArr[i].salary.average = salary.to
            continue
          }
          if (salary.from) newArr[i].salary.average = salary.from
        } else {
          delete newArr[i]
        }
      }

      // сортировка по среднему ключу salary.average , если он есть.
      newArr = newArr.sort((a, b) => {
        if (a.salary && b.salary) {
          /* среднее по usd */
          if (a.salary.currency === 'USD' && b.salary.currency === 'USD') {
            if (a.salary.average < b.salary.average) return 1
            if (a.salary.average > b.salary.average) return -1
          }
          if (b.salary.currency === 'USD' && a.salary.currency === 'USD') {
            if (b.salary.average < a.salary.average) return 1
            if (b.salary.average > a.salary.average) return -1
          }
          /* --- */

          if (a.salary.currency === 'USD' || a.salary.currency === 'EUR') {
            if (a.salary.average * 60 < b.salary.average) return 1
            if (a.salary.average * 60 > b.salary.average) return -1
          }

          if (b.salary.currency === 'USD' || b.salary.currency === 'EUR') {
            if (a.salary.average < b.salary.average * 60) return 1
            if (a.salary.average > b.salary.average * 60) return -1
          }

          if (a.salary.average < b.salary.average) return 1
          if (a.salary.average > b.salary.average) return -1
        }
        return 0
      })
      newArr = newArr.filter(Boolean)
      newArr = newArr.map((elem) => {
        if (elem.salary.average !== 'undefined') return elem
      })
      //newArr = newArr.sort((a, b) => b.salary.average - a.salary.average);
      setSalaryArray(newArr)
      setCopySalary(newArr)
    }
  }, [allJobs])
  useEffect(() => {
    let newArr = JSON.parse(JSON.stringify(salaryArray))
    newArr = newArr.reverse()
    /*newArr.sort((a, b) => a.salary.average - b.salary.average);*/
    setCopySalary(newArr)
  }, [salaryArray])
  const salaryArrayFilter = useMemo(() => {
    const result = []
    if (salaryArray.length === 0) return []
    const filter = salaryArray
      .filter((elem) => elem.salary.average)
      .map((elem) => elem.salary.average)
    const max = Math.max(...filter)
    const min = Math.min(...filter)
    const diff = max - min
    for (let i = 0; i < 4; i++) {
      result.push(min + diff * (i / 5))
    }
    result.push(max)
    return result.reverse()
  }, [salaryArray])
  return (
    <>
      {allJobs?.length > 0 ? (
        <div style={{ position: 'relative' }}>
          <div className="analytics_block-vertical">
            <div className="block_diapazon">
              {salaryArrayFilter
                // .filter((elem) => elem.salary.average)
                .map((elem, indx) => {
                  return (
                    <React.Fragment key={indx}>
                      <div className={'line_row'}>
                        {/* <div className="company">{calcSalary(elem)}</div> */}
                        <div className="company">{elem} ₽</div>
                        <img src={verical_line_chart} />
                      </div>
                    </React.Fragment>
                  )
                })}
            </div>
            <div className={'vertical_progress'}>
              {copySalary
                .filter((elem) => elem.salary.average)
                .map((elem, indx) => {
                  return (
                    <VerticalProgress
                      percent={calcVerticalPercent(indx)}
                      name={elem.employer.name}
                      elem={{ ...elem }}
                      setActiveVacancy={setActiveVacancy}
                      activeVacancy={activeVacancy}
                      key={indx}
                    />
                  )
                })}
            </div>
          </div>
        </div>
      ) : flagLoadingVacancy ? (
        <Spin style={{ position: 'relative', top: '50px' }} />
      ) : activeProfession?.professionTitle ? (
        <div className="no_vacancies">По вашему запросу ничего не найдено</div>
      ) : (
        <div className="no_vacancies">{variables_11}</div>
      )}
    </>
  )
}

export default ParentBlockProgressVertical
